<!--
 * @Author: wzh
 * @LastEditTime: 2023-05-29 16:54:48
 * @Description: 偏好设置
-->
<template>
  <div class="love_set">
    <div>
      <Head :title="$t('home.love_set.second_auth_set')" :iconUrl="require('@/assets/images/love/second_icon.png')" />

      <div class="content_flex" v-if="setObj.secAuthApps.length">
        <span class="title">{{ $t("home.love_set.second_auth_app") }}{{ $t("base.punctuation.colon") }}</span>
        <div class="list">
          <a-checkbox
            v-for="(item, index) in setObj.secAuthApps"
            :key="item.appId"
            :checked="item.status == 3 ? false : true"
            :disabled="item.status == 1"
            @change="(e) => handleChange(e, index)"
          >
            {{ item.appName }}
          </a-checkbox>
        </div>
      </div>
      <a-empty v-else :image="simpleImage" :description="$t('home.love_set.not_app')" />
    </div>
    <!-- 其他设置 -->
    <div style="margin-top: 50px">
      <Head :title="$t('home.love_set.other_set')" :iconUrl="require('@/assets/images/love/second_icon.png')" />

      <div class="content">
        <div>
          <a-checkbox v-model="setObj.singlesignon">{{ $t("home.love_set.single_login") }}</a-checkbox>
        </div>
        <div style="margin-top: 20px" v-if="msgShow">
          <!-- 移动校园、短信、企业微信、邮箱 -->
          <a-checkbox v-model="setObj.pwdchangenotice">{{ $t("home.love_set.password_change") }}</a-checkbox>
        </div>
      </div>
    </div>

    <div class="submit">
      <a-button style="width: 25%" type="primary" :loading="loading" @click="handleOk">{{
        $t("base.btn.save")
      }}</a-button>
    </div>
  </div>
</template>

<script>
import Head from "../compontents/Head";
import { commonAPI } from "@/apis";
import { Empty } from "ant-design-vue";

export default {
  components: { Head },
  name: "love",
  data() {
    return {
      loading: false,
      setObj: {
        singlesignon: false,
        pwdchangenotice: false,
        secAuthApps: [],
        userId: "",
      },
      msgShow: false,
    };
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  created() {
    this.getInfo();
    this.getSafeSet();
  },
  methods: {
    // 回显信息
    async getInfo() {
      const { code, data, message } = await commonAPI.getAction("/expand/setting/getOne");
      if (code == 0) {
        this.setObj = {
          singlesignon: data.singlesignon || false,
          pwdchangenotice: data.pwdchangenotice || false,
          secAuthApps: data.secAuthApps || [],
          userId: data.userId,
        };
      } else {
        this.$message.error(message);
      }
    },

    // author: wzh, date: 2023-05-29, for: 获取安全配置，控制是否可通知
    async getSafeSet() {
      const { code, data, message } = await commonAPI.getAction("setting/safe/get");
      if (code == 0) {
        let obj = { ...data };
        this.msgShow = obj.sfxtyhpzmmbdtx == 1 ? true : false;
      } else {
        this.$message.error(message);
      }
    },

    // 应用勾选change
    handleChange(e, index) {
      let status = e.target.checked ? "2" : "3";
      this.$set(this.setObj.secAuthApps[index], "status", status);
    },
    // 提交
    async handleOk() {
      let params = { ...this.setObj };
      this.loading = true;
      const { code, message } = await commonAPI.postAction("/expand/setting/addOrUpdate", params);
      if (code == 0) {
        this.$message.success(this.$t("home.love_set.save_success"));
      } else {
        this.$message.error(message);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="less">
.love_set::v-deep {
  .content_flex {
    margin: 20px 40px;
    display: flex;
    .title {
      width: 160px;
    }
    .list {
      flex: 1;
    }
  }

  .ant-empty {
    margin: 10px 0;
  }

  .content {
    margin: 20px 40px;
  }

  .submit {
    text-align: center;
    margin-top: 75px;
  }
}
</style>
